import React from "react";
import FormRadioButton from "../FormRadioButton";
import "./BoxClink.css";

class BoxClink extends React.Component {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
  }
  handler(event) {
    event.stopPropagation();
    var radio = event.currentTarget.getElementsByTagName("input")[0];
    radio.checked = true;
    this.props.handler(radio.value)
  }
  render() {
    return (
      <div id="box-clink" className={this.props.visible?'':'hidden'}>
        <h2>
          La filiale è troppo distante?<br />
          Non ti preoccupare, veniamo noi da te.<br />
          Fissa un appuntamento con un consulente.
        </h2>
        <div className="grid-x">
          <div className="cell medium-6">
            <FormRadioButton
              handler={this.handler}
              validate="rb"
              name="clink"
              label="Si"
              value="1"
            />
          </div>
          <div className="cell medium-6">
            <FormRadioButton
              handler={this.handler}
              validate="rb"
              name="clink"
              label="No"
              value="2"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default BoxClink;


// WEBPACK FOOTER //
// ./src/components/dati_personali/components/BoxClink/index.js